import { Books } from '@velocity-exchange/icons';

import IconButton from 'src/components/primitives/IconButton/IconButton';
import Tooltip from 'src/components/primitives/Tooltip/Tooltip';

export const AccountSwitchHotkeyExplainer = () => {
	return (
		<Tooltip delayDuration={0} content={<TooltipContent />}>
			<IconButton variant="tertiary" size="lg" icon={Books} />
		</Tooltip>
	);
};

const TooltipContent = () => {
	return (
		<div className="flex flex-col items-start justify-start gap-3 p-0">
			<div className="typo-label-xs font-bold text-text-default">
				Switch Accounts Hotkey
			</div>
			<div className="flex w-full items-center">
				<div className="typo-body-2xs">
					Use this key combo to jump between subaccounts
				</div>
			</div>
			<div className="flex w-full items-center">
				<div className="flex items-center gap-2">
					<div className="rounded-md bg-button-secondary-bg px-3 py-2 typo-label-xs">
						D
					</div>
					<div className="typo-label-xs">+</div>
					<div className="rounded-md bg-button-secondary-bg px-3 py-2 typo-label-xs">
						Tab
					</div>
				</div>
			</div>
		</div>
	);
};
